import React from "react";
import { Button, Heading } from "@flixbus/honeycomb-react";
import { Icon, IconInfoSolid } from "@flixbus/honeycomb-icons-react";
import styles from "./CalculationInputEmptyState.module.scss";

interface CalculationInputEmptyStateProps {
  onCreate: () => void;
}

const CalculationInputEmptyState: React.FC<CalculationInputEmptyStateProps> = ({
  onCreate,
}) => (
  <div className={styles.container}>
    <Icon InlineIcon={IconInfoSolid} size={6} extraClasses={styles.icon} />
    <Heading size={4} flushSpace>
      No calculations yet
    </Heading>
    <Button appearance="primary" onClick={onCreate}>
      Create calculation
    </Button>
  </div>
);

export default React.memo(CalculationInputEmptyState);
